import React, { useRef, useState } from 'react';
import { Upload, X, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../../App';

const CoverImageUploader = ({ value, onChange }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      toast.error('Please choose an image.');
      return;
    }
    if (file.size > 8 * 1024 * 1024) {
      toast.error('Image too large. Max 8MB.');
      return;
    }
    const fd = new FormData();
    fd.append('file', file);
    setUploading(true);
    try {
      const resp = await API.post('/admin/blog/upload-image', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      onChange(resp.data?.url || '');
      toast.success('Cover image uploaded.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Upload failed.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid="cover-image-uploader">
      {value ? (
        <div className="relative inline-block group">
          <img src={value} alt="Cover" className="max-h-40 rounded-sm border border-[#E7E5E4]" />
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-white border border-[#E7E5E4] text-[#BC562B] hover:bg-[#BC562B] hover:text-white flex items-center justify-center shadow-sm transition-colors"
            title="Remove cover image"
            data-testid="cover-image-remove"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="flex items-center gap-2 border border-dashed border-[#E7E5E4] hover:border-[#2C5530] text-[#57534E] hover:text-[#1A1A1A] px-4 py-3 transition-colors disabled:opacity-50"
          data-testid="cover-image-upload-btn"
        >
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {uploading ? 'Uploading…' : 'Upload cover image'}
        </button>
      )}
      <div className="mt-2">
        <input
          type="url"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="…or paste an image URL"
          className="w-full text-sm"
          data-testid="cover-image-url-input"
        />
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
    </div>
  );
};

export default CoverImageUploader;
